import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import ProtectedRoute from './protected/ProtectedRoute';
import Support from 'pages/support/Support';
import SupportTicket from 'pages/SupportTicket/SupportTicket';
import Announcements from 'pages/Announcements/Announcements';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const crm = Loadable(lazy(() => import('pages/CRMLeads/index')));
const fundManagers = Loadable(lazy(() => import('pages/fundManager/FundManager')));
const investors = Loadable(lazy(() => import('pages/Investors/investors')));
const admins = Loadable(lazy(() => import('pages/AdminsManagement/index')));
const reports = Loadable(lazy(() => import('pages/ReportsManagement/index')));
const documents = Loadable(lazy(() => import('pages/DocumentsManagement/index')));
const suppliers = Loadable(lazy(() => import('pages/suppliers/index')));
const deals = Loadable(lazy(() => import('pages/Deals/index')));
const subscription = Loadable(lazy(() => import('pages/Subscription/index')));
const roles = Loadable(lazy(() => import('pages/RoleManagement/index')));
const messages = Loadable(lazy(() => import('pages/Messages/index')));
const editProfile = Loadable(lazy(() => import('pages/profile/Profile')));
const unauthorized = Loadable(lazy(() => import('pages/UnAuthorizedAccessDenied/index')));

// ==============================|| MAIN ROUTING ||============================== //

const PrimaryRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <ProtectedRoute component={DashboardDefault} />
    },
    {
      path: 'dashboard',
      element: <ProtectedRoute component={DashboardDefault} />
    },
    {
      path: 'fund-managers-list',
      element: <ProtectedRoute component={fundManagers} />
    },
    {
      path: 'investors-list',
      element: <ProtectedRoute component={investors} />
    },
    {
      path: 'suppliers',
      element: <ProtectedRoute component={suppliers} />
    },
    {
      path: 'documents',
      element: <ProtectedRoute component={documents} />
    },
    {
      path: 'reports',
      element: <ProtectedRoute component={reports} />
    },
    {
      path: 'support',
      element: <ProtectedRoute component={Support} />
    },
    {
      path: 'announcements',
      element: <ProtectedRoute component={Announcements} />
    },
    {
      path: 'Announcements',
      element: <ProtectedRoute component={Announcements} />
    },
    {
      path: 'support/ticket',
      element: <ProtectedRoute component={SupportTicket} />
    },
    {
      path: 'profile',
      element: <ProtectedRoute component={editProfile} />
    },
    {
      path: 'admins',
      element: <ProtectedRoute component={admins} />
    },
    {
      path: 'crm',
      element: <ProtectedRoute component={crm} />
    },
    {
      path: 'deals',
      element: <ProtectedRoute component={deals} />
    },
    {
      path: 'subscription',
      element: <ProtectedRoute component={subscription} />
    },
    {
      path: 'roles',
      element: <ProtectedRoute component={roles} />
    },
    {
      path: 'messages',
      element: <ProtectedRoute component={messages} />
    },
    {
      path: 'unauthorized',
      element: <ProtectedRoute component={unauthorized} />
    }
  ]
};

export default PrimaryRoutes;
